import React, { Component } from 'react';
import Navigation from './Navigation';

class Header extends Component {
  componentDidMount() {
    const jquery = window.$;
    jquery(window).scroll(function(){
      let perc = 100 - (jquery(window).scrollTop() / 20);
      if (perc < 80) perc = 75;

      jquery(".h-banner").css("opacity", 1 - jquery(window).scrollTop() / 800);
    });
  }

  render() {
    return (
      <header>
        <Navigation />
        <div id={this.props.id} className="h-banner view">
            <div className="full-bg-img rgba-black-light">
                <div className="container flex-center">
                    <div className="row pt-5 mt-3">
                        <div className="col-md-12">
                            <div className="text-center">
                                <h1 className="anim_piece">{this.props.title}</h1>
                                <h5 className="anim_piece">{this.props.sub}</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </header>
    );
  }
}

export default Header;
